/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slimy_Home_Goat_TapInputs */

const es_slimy_home_goat_tap = /** @type {(inputs: Slimy_Home_Goat_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayuda`)
};

const gl_slimy_home_goat_tap = /** @type {(inputs: Slimy_Home_Goat_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Axuda`)
};

const en_slimy_home_goat_tap = /** @type {(inputs: Slimy_Home_Goat_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help`)
};

/**
* | output |
* | --- |
* | "Help" |
*
* @param {Slimy_Home_Goat_TapInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const slimy_home_goat_tap = /** @type {((inputs?: Slimy_Home_Goat_TapInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slimy_Home_Goat_TapInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_slimy_home_goat_tap(inputs)
	if (locale === "en") return en_slimy_home_goat_tap(inputs)
	return es_slimy_home_goat_tap(inputs)
});